module.exports = __webpack_public_path__ + "img/icom2.3f96d60d.png";